<template>
  <div class="other-bg" :style="{ backgroundImage: 'url(' + BG + ')' }">
    <div class="container-cm">
      <div class="sidemap">
        <a href="#U" title="中央內容區塊" id="AU" accesskey="U" name="U">:::</a>
      <a href="/Sitemap" title="網站導覽">網站導覽</a>
      </div>
    </div>
    <div class="container-cm">
      <h1 class="logo">
        <a href="/" title="農科院農業課程報名及查詢系統:回首頁">
          <img src="../assets/images/LOGO.png" alt="農科院農業課程報名及查詢系統:回首頁" />
        </a>
      </h1>
      <main class="training-content">
        <h2 class="training-h2-ie">網站導覽</h2>
        <div class="table-line"></div>
        <div class="training-detail-container">
          <div class="training-detail-content">
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C">:::</a>
            <p class="sidemap_p">
              本網站依無障礙網頁設計原則建置，網站的主要內容分為二大區塊：<br>
1. 上方功能區塊、2. 中央內容區塊。
<br>
<br>
本網站的快速鍵﹝Accesskey﹞設定如下：<br>
<ul>
  <li>Alt+U：上方功能區塊。</li>
  <li>Alt+C：中央內容區塊，為本頁主要內容區。</li>
</ul>
<br>
<br>
本網站的小月曆鍵盤操作說明如下：
<ul>
  <li>page up/down：切換月</li>
  <li>ctrl+page up/down：切換年</li>
  <li>ctrl+left/right：切換天</li>
  <li>ctrl+up/down：切換週</li>
  <li>enter：確定選擇日期</li>
  <li>escape：關閉並取消選擇</li>
</ul>
            </p>
            <br>
            <br>
            <ol class="sidemap_p">
              <li>1.<a href="/" title="首頁">首頁</a></li>
              <li>2.<a href="/Course/Index" title="課程列表">課程列表</a></li>
              <li>3.<a href="/Course/ParticipantSearch" title="報名查詢">報名查詢</a></li>
              <li>4.<a href="/Course/Search" title="課程查詢">課程查詢</a></li>
            </ol>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import BG from '../assets/images/content_BG01.jpg';

export default {
  name: 'sidemap',
  components: {
    Footer,
  },
  data() {
    return {
      BG,
    };
  },
  methods: {},
  created() {},
  mounted() {},
  filters: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.sidemap_p {
  font-size: 1.2rem;
  line-height: 1.5;
}

.other-bg {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}

.training-content {
  padding: 0 4rem 300px 4rem;
  @media (max-width: 1024px) {
    padding: 0 0 300px 0;
  }
}

.training-h2 {
  background: linear-gradient(to bottom, #a0c8c0 0, #5aa3a8 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h2-ie {
  color: #5aa3a8;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h3 {
  font-size: 1.5rem;
  text-align-last: left;
}

.table-line {
  height: 1px;
  background-color: #edf1f1;
  width: 100%;
}

#AC,
#AU {
  color: transparent;
}

.training-detail-container {
  padding: 0.6rem 5rem;
  @media (max-width: 1024px) {
    padding: 0.6rem 0;
  }
}

.training-detail-content {
  background-color: #fff;
  border-radius: 1rem;
  padding: 4.5rem 5rem 4.5rem 9rem;
  box-shadow: 0 0 3px 3px rgba(227, 232, 232, 0.5);
  @media (max-width: 1024px) {
    padding: 1.5rem;
  }
  .list {
    display: flex;
    font-size: 1.1rem;
    color: #3e3e3f;
    letter-spacing: 1.5px;
    line-height: 2;
    @media (max-width: 420px) {
      flex-direction: column;
      margin-bottom: 2rem;
    }
    .title {
      min-width: 100px;
      display: inline-block;
      text-align: right;
      margin-right: 30px;
      @media (max-width: 420px) {
        text-align: left;
      }
    }
    .content {
      width: 100%;
      display: inline-block;
    }
  }
  .btn-box {
    display: flex;
    justify-content: flex-end;
    padding-top: 5.5rem;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
    }

    a:first-child {
      margin-right: 1.5rem;

      @media (max-width: 767px) {
        margin-right: 0;
        margin-bottom: 1.5rem;
      }
    }
  }
  .btn {
    display: block;
    color: #fff;
    border-radius: 5rem;
    padding: 0.5rem 0;
    width: 120px;
    font-size: 1.5rem;
    letter-spacing: 5px;
    text-decoration: none;
    text-align: center;

    &.light-green {
      background-color: #4dba95;
    }

    &.dark-green {
      background-color: #8bb75f;
    }
  }
}
</style>

<style lang="scss">
.pop-check {
  text-align: center;
  font-size: 1.5rem;
  color: #f98d28;
  padding: 10px 0;
  input[type="checkbox"] {
    border: 2px solid #f98d28;
    width: 16px;
    height: 16px;
  }
}

// sweetalert 客製
.swal2-content {
  padding: 0 1rem;

  p {
    text-align-last: left;
    font-size: 1.1rem;
  }
}

.swal2-styled.swal2-confirm,
.swal2-styled.swal2-cancel {
  font-size: 1.5rem;
  border-radius: 5rem;
  font-weight: bold;
  padding: 10px 55px;
}

.swal2-styled:focus {
  outline: 3px dashed #5da3ab;
}
</style>
